import React, { useEffect, useMemo, useRef, useState } from 'react';
import PageHeader from '../../../components/PageHeader';
import useGeoBootstrap from '../hooks/useGeoBootstrap';
import useGeoFilters from '../hooks/useGeoFilters';
import useGeoInsights from '../hooks/useGeoInsights';
import GeoInsightsSummary from '../components/GeoInsightsSummary';
import GeoFiltersDrawer from '../components/GeoFiltersDrawer';
import { GEO_PAGE_TITLE } from '../utils/geoConstants';

export default function GeoInsights() {
  const { loading: bootstrapLoading, config } = useGeoBootstrap();
  const filters = useGeoFilters({ mode: 'insights', config });
  const {
    showTableFilters,
    setShowTableFilters,
    hasFiltersApplied,
    handleClearFilters,
    insightsParams,
  } = filters;

  const { insights, loading: insightsLoading, error } = useGeoInsights({
    insightsParams,
    enabled: !bootstrapLoading,
  });

  const loading = bootstrapLoading || insightsLoading;

  const paramsKey = useMemo(() => JSON.stringify(insightsParams), [insightsParams]);
  const [contentAnimationKey, setContentAnimationKey] = useState(0);
  const lastAnimatedParamsRef = useRef(null);

  useEffect(() => {
    if (loading) return;
    if (lastAnimatedParamsRef.current === paramsKey) return;
    lastAnimatedParamsRef.current = paramsKey;
    setContentAnimationKey((key) => key + 1);
  }, [loading, paramsKey]);

  return (
    <>
      <PageHeader
        title={GEO_PAGE_TITLE}
        activePageTab="Insights"
        hasFiltersApplied={hasFiltersApplied}
        onClearFilters={handleClearFilters}
        showTableFilters={showTableFilters}
        onToggleFilters={() => setShowTableFilters((open) => !open)}
      />
      <div className="body">
        <div className="table-area geo-analytics-panel insights-panel">
          {contentAnimationKey > 0 ? (
            <div key={contentAnimationKey} className="geo-insights-content">
              <GeoInsightsSummary
                insights={insights}
                loading={loading}
                error={error}
              />
            </div>
          ) : (
            <GeoInsightsSummary
              insights={insights}
              loading={loading}
              error={error}
            />
          )}
        </div>
      </div>

      <GeoFiltersDrawer
        isOpen={showTableFilters}
        onClose={() => setShowTableFilters(false)}
        filters={filters}
      />
    </>
  );
}
